import { apiSlice } from "@app/api/apiSlice";

export const campaignManageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllCampaigns: builder.query({
      query: (query) => `campaign?${query}`,
    }),
    loadOneCampaign: builder.query({
      query: (id) => `campaign/${id}`,
    }),
    saveOneCampaign: builder.mutation({
      query: (body) => ({
        url: "campaign",
        method: "POST",
        body,
      }),
    }),
    deleteOneCampaign: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `campaign/${id}`,
      }),
    }),

    loadAllOfficeType: builder.query({
      query: (query) => `office?${query}`,
    }),

    loadAllCampaignAccess: builder.mutation({
      query: (id) => `campaign/access/${id}`,
    }),
    saveCampaignAccess: builder.mutation({
      query: ({ body, id }) => ({
        url: `campaign/access/${id}`,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadAllCampaignsQuery,
  useLoadOneCampaignQuery,
  useSaveOneCampaignMutation,
  useDeleteOneCampaignMutation,
  useLoadAllCampaignAccessMutation,
  useSaveCampaignAccessMutation,
  useLoadAllOfficeTypeQuery
} = campaignManageApiSlice;
